/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftDownIcon16Solid = forwardRef('ArrowDUturnLeftDownIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.125 7.25a5.875 5.875 0 0 1 11.75 0v4.5a1.125 1.125 0 0 1-2.25 0v-4.5a3.625 3.625 0 0 0-7.25 0v3.791l2.034-2.288a1.125 1.125 0 1 1 1.682 1.494l-3.253 3.66c-.845.95-2.33.95-3.176 0l-3.253-3.66a1.125 1.125 0 1 1 1.682-1.494l2.034 2.288V7.25Z" })));
});
